import {
  dimensiondata_1_tetelek_1_2_3_4_5_group_w200_row,
  dimensiondata_2_termekek_group_1_2_column,
  dimensiondata_2_termekek_group_column,
  ezer_tonna_value_1_data_precision,
  TJ_value_2_data_precision,
  year_column_expanded,
  order_1,
  order_2
} from '../../fields';
import { PivotGridConfig } from '../../utils/pivot-grid-config';

export const evesSzenMerlegConfig: PivotGridConfig = {
  showChart: false,
  filterYear: {},
  options: {
    store: {
      version: 4,
      type: 'odata',
      url: 'odata/v4/public/EvesSzenMerleg',
      select: ['date', 'dimension_1', 'dimension_2', 'value_1', 'value_2'],
      beforeSend: (e: any) => {
        e.headers = {
          Accept: 'application/json;odata.metadata=none',
        };
      },
    },
    retrieveFields: false,
    fields: [
      ...dimensiondata_1_tetelek_1_2_3_4_5_group_w200_row,
      year_column_expanded,
      ...dimensiondata_2_termekek_group_1_2_column,
      ezer_tonna_value_1_data_precision,
      TJ_value_2_data_precision,
      order_1,
      order_2
    ],
  },
};
